import { render, staticRenderFns } from "./WorkTab.vue?vue&type=template&id=d83b04c2"
import script from "./WorkTab.vue?vue&type=script&lang=js"
export * from "./WorkTab.vue?vue&type=script&lang=js"
import style0 from "./WorkTab.vue?vue&type=style&index=0&id=d83b04c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports